import Avatar from "./Avatar";
import Stopp from "./Stopp";
import { WartePunkte } from "./StatusPille";
import Ziffernblock, { ZiffernFest } from "./Ziffernblock";
import "./BuzzerArea.css";

/**
 * Daumenzone der Mitspieler (und des mitspielenden Hosts): Buzzer samt
 * Sperrlogik, in der Jahres-Runde der Ziffernblock.
 *
 * Wer selbst dran ist, bekommt hier NICHTS — das zeigt DuBistDran als
 * eigener Bildschirm. hideBuzzButton: der Host buzzert ueber seinen
 * STOPP-Knopf; er sieht hier nur, wer dran ist bzw. dass er raus ist.
 * farbe(name) -> 1..8 fuer die Avatare.
 * @category spiel
 */
export function BuzzerArea({ room, jahrTipp, setJahrTipp, hideBuzzButton = false, farbe = () => 1 }) {
  const r = room.room;
  if (!r) return null;
  const myId = room.myPlayerId;
  if (!myId) return null;

  const buzz = r.buzz;
  const lockedOut = (r.lockedOut || []).includes(myId);
  const iHaveFloor = buzz && buzz.playerId === myId;
  const someoneElse = buzz && buzz.playerId !== myId;

  // Bei "Jahr" ist der Buzzer bewusst gesperrt: getippt wird.
  if (r.game?.taskType === "YEAR") {
    // Nach der Auswertung zeigt der Bildschirm selbst die Uebersicht
    if (r.yearResult) return null;
    const abgegeben = (r.yearSubmitted || []).includes(myId);
    const spieler = r.players || [];

    if (abgegeben) {
      const getippt = new Set(r.yearSubmitted || []);
      return (
        <div className="buzzer-zone jahr-abgegeben">
          <span className="ueberzeile">Dein Tipp</span>
          <ZiffernFest wert={room.myYearGuess} />
          <div className="wer-tippt">
            {spieler.map((p) =>
              getippt.has(p.id) ? (
                <Avatar key={p.id} name={p.name} farbe={farbe(p.name)} groesse="klein" />
              ) : (
                <Avatar key={p.id} name={p.name} farbe={farbe(p.name)} groesse="klein" className="offen" />
              )
            )}
            <span className="hinweis-text">
              {getippt.size} von {spieler.length} haben getippt
            </span>
          </div>
        </div>
      );
    }

    return (
      <div className="buzzer-zone">
        <Ziffernblock
          wert={jahrTipp}
          onChange={(w) => setJahrTipp(w.replace(/\D/g, "").slice(0, 4))}
          onAbschicken={() => {
            const jahr = parseInt(jahrTipp, 10);
            if (!Number.isFinite(jahr) || jahr < 1000 || jahr > 9999) return;
            // Nur leeren, wenn der Tipp rausging (Socket kann kurz zu sein)
            if (room.sendYearGuess(jahr)) setJahrTipp("");
          }}
        />
      </div>
    );
  }

  if (iHaveFloor) return null;

  if (someoneElse) {
    return (
      <div className={`warteflaeche${hideBuzzButton ? "" : " buzzer-hoch"}`} role="status">
        <Avatar name={buzz.name} farbe={farbe(buzz.name)} groesse={hideBuzzButton ? undefined : "gross"} puls />
        <span className="wer">
          <b>{buzz.name} ist dran</b>
          <span>
            Kurz warten <WartePunkte />
          </span>
        </span>
      </div>
    );
  }

  if (lockedOut) {
    // Sobald aufgeloest ist, raet niemand mehr weiter
    if (r.lastSolution || r.yearResult) return null;
    if (hideBuzzButton) {
      return (
        <div className="warteflaeche" role="status">
          Für diesen Song bist du raus
        </div>
      );
    }
    return (
      <Stopp
        aus
        gross
        icon="schloss"
        text="Für diesen Song bist du raus"
        unterzeile="Die anderen raten weiter"
      />
    );
  }

  // Beim Host ist der STOPP-Knopf sein Buzzer — kein zweiter.
  if (hideBuzzButton) return null;

  if (!r.buzzArmed) {
    return <Stopp aus gross icon={<WartePunkte />} text="Gleich geht's los" />;
  }

  return (
    <Stopp
      gross
      scharf
      unterzeile="Tippen, sobald du's weißt"
      // pointerdown statt click: der Buzzer soll im Moment der Beruehrung
      // reagieren, nicht erst beim Loslassen.
      onPointerDown={(e) => {
        e.preventDefault();
        if (r.buzzArmed) room.buzz();
      }}
    >
      STOPP
    </Stopp>
  );
}

export default BuzzerArea;
